export default __webpack_public_path__ + "static/media/outcess1.a63d3c7b.jpeg";